<template>
  <v-col class="info-container elevation-2 pa-0 mr-5">
    <v-row class="info-title px-5 py-1 ma-0"
    :style="
      `background-color: ${ color }; !important`
    ">
      <h2>{{ title }}</h2>
    </v-row>

    <div class="justify-center align-items-center px-8 ma-0 pt-3">
      <slot />
    </div>

    <v-spacer />

    <v-row class="justify-center align-items-center px-5 ma-0 align-self-end">
      <slot name="footer" />
    </v-row>
  </v-col>
</template>
<script>
export default {
  props: {
    value: { type: Object, default: () => {} },
    title: { type: String, default: "" },
    color: { type: String, default: "" }
  },
  methods: {
    onTextChanged(field, text) {
      this.$emit("input", { ...this.value, [field]: text });
    }
  }
};
</script>
<style lang="sass">
.info-title
  color: white
  border-top-left-radius: 15px
  border-top-right-radius: 15px

.info-container
  min-height: 250px !important
  max-width: 600px !important
  border-radius: 15px !important
</style>
